/* eslint-disable no-unused-vars */
import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import useFormValidator from 'useFormValidator';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as actions from '../../../action';
import * as c from '../../../constant';
import Garbage from './common/Garbage';
import License from './common/License';
import Permit from './common/Permit';
import Sanitary from './common/Sanitary';

function CreateRangeModal({
  newBusinessNaturesId,
  createNewBusinessLines,
  getNewBusinessLinesList,
  creating,
  ordinanceRevisionId,
}) {
  const [formData, setFormData] = useState({
    code: '',
    name: '',
    garbage_code: '',
    license_code: '',
    permit_code: '',
    sanitary_code: '',
  });

  const validateForm = useFormValidator(formData, {
    code: 'required',
    name: 'required',
  });
  const setModal = useContext(ModalContext);

  const handleOnSubmit = e => {
    e.preventDefault();
    if (!validateForm.response.is_passed) {
      return false;
    }

    const args = {
      ...formData,
      ordinance_revision_id: ordinanceRevisionId,
      code: _.get(formData, 'code').toUpperCase(),
    };

    return createNewBusinessLines(newBusinessNaturesId, args, () => {
      setModal({ isOpen: false });
      getNewBusinessLinesList(newBusinessNaturesId, {ordinance_revision_id: ordinanceRevisionId});
    });
  };

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const handleOnChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label className="full-label mb-0">
              Code: {validateForm.renderMessage('code')}
            </label>
            <input
              className="form-control"
              type="text"
              name="code"
              onChange={handleOnChange}
              placeholder="Ex. CODE-1234"
              style={{ textTransform: 'uppercase' }}
              value={_.get(formData, 'code')}
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Name: {validateForm.renderMessage('name')}
            </label>
            <input
              className="form-control"
              type="text"
              name="name"
              onChange={handleOnChange}
              value={_.get(formData, 'name')}
            />
          </div>
          <div className="col-6 form-group">
            <label>License Code</label>
            <License
              name="license_code"
              onChange={handleOnChange}
              ordinanceRevisionId={ordinanceRevisionId}
              value={_.get(formData, 'license_code') || ''}
            />
          </div>
          <div className="col-6 form-group">
            <label>Permit Code</label>
            <Permit
              name="permit_code"
              onChange={handleOnChange}
              ordinanceRevisionId={ordinanceRevisionId}
              value={_.get(formData, 'permit_code') || ''}
            />
          </div>
          <div className="col-6 form-group">
            <label>Sanitary Code</label>
            <Sanitary
              name="sanitary_code"
              onChange={handleOnChange}
              ordinanceRevisionId={ordinanceRevisionId}
              value={_.get(formData, 'sanitary_code') || ''}
            />
          </div>
          <div className="col-6 form-group">
            <label>Garbage Code</label>
            <Garbage
              name="garbage_code"
              onChange={handleOnChange}
              ordinanceRevisionId={ordinanceRevisionId}
              value={_.get(formData, 'garbage_code') || ''}
            />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={creating || !validateForm.response.is_passed}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3   "
          >
            <span className="font-weight-bold">Submit</span>
          </button>
          <button
            disabled={creating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

CreateRangeModal.propTypes = {
  newBusinessNaturesId: PropTypes.string.isRequired,
  getNewBusinessLinesList: PropTypes.instanceOf(Function).isRequired,
  createNewBusinessLines: PropTypes.instanceOf(Function).isRequired,
  creating: PropTypes.bool.isRequired,
  ordinanceRevisionId: PropTypes.number.isRequired,
};

const mapStateToProps = ({ api }) => ({
  creating: api.loading.indexOf(c.CREATE_NEW_BUSINESS_LINES) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(CreateRangeModal);
